import { configureStore } from '@reduxjs/toolkit';
import { authService } from './services/auth';
import { authSlice } from './slices/auth';
import { userService } from './services/user';
import { userSlice } from './slices/user';
import { masterDataService } from './services/masterData';
import { taskService } from './services/task';
import { kanbanService } from './services/kanban';
import { homeService } from './services/home';
import { projectsApi } from './services/project';
import { milestoneService } from './services/milestone';
import { globalSearchService } from './services/globalSearch';
import { notificationService } from './services/notifications';
import { reportService } from './services/report';
import { timesheetService } from './services/timesheet';
import { companyService } from './services/company';

const store = configureStore({
  reducer: {
    [authService.reducerPath]: authService.reducer,
    [userService.reducerPath]: userService.reducer,
    [masterDataService.reducerPath]: masterDataService.reducer,
    [taskService.reducerPath]: taskService.reducer,
    [kanbanService.reducerPath]: kanbanService.reducer,
    [homeService.reducerPath]: homeService.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [milestoneService.reducerPath]: milestoneService.reducer,
    [globalSearchService.reducerPath]: globalSearchService.reducer,
    [notificationService.reducerPath]: notificationService.reducer,
    [reportService.reducerPath]: reportService.reducer,
    [timesheetService.reducerPath]: timesheetService.reducer,
    [companyService.reducerPath]: companyService.reducer,
    auth: authSlice.reducer,
    user: userSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(
    {
      serializableCheck: {
        ignoredActions: [
          'timesheetService/executeMutation/fulfilled',
          'timesheetService/executeMutation/rejected',
          'reportService/executeMutation/rejected',
          'reportService/executeMutation/fulfilled',
        ],
        ignoredPaths: ['timesheetService.mutations', 'reportService.mutations'],
      },
    },
  )
    .concat(
      authService.middleware,
      masterDataService.middleware,
      userService.middleware,
      taskService.middleware,
      kanbanService.middleware,
      homeService.middleware,
      projectsApi.middleware,
      milestoneService.middleware,
      globalSearchService.middleware,
      notificationService.middleware,
      reportService.middleware,
      timesheetService.middleware,
      companyService.middleware,
    ),
});
export default store;
